export default "__VITE_ASSET__To_qCFX6__"